import React, {useEffect, useState} from 'react'
import { TableWrapper } from '../../../libs/react-mpk/wrapper'
import Modal from '../../../libs/react-mpk/components/Modal'
import t from 'counterpart'
import service from './StatusPajakPenjual.service'
import moment from 'moment'
import { toast } from '../../../libs/react-mpk/services'

const StatusPajakPenjualTable = ({
  className       = '',
  showCommandbar  = true,
  history
}) => {

  const [confirmDelete, setConfirmDelete] = useState(false)
  const [confirmDeleteData, setConfirmDeleteData] = useState({})

  function _closeConfirmDelete() {
    setConfirmDelete(false)
  }
  async function _submitConfirmDelete(callback) {
    var r = await service.delete(confirmDeleteData.id)
    toast.info(`Data ${confirmDeleteData.nama} telah di hapus.`); callback()
    setConfirmDelete(false)
  }

  return (
    <>
    <TableWrapper
      baseId="mod-table-sample"
      title={t.translate('modules.statusPajakPenjual.title')}
      className={className}
      // hintMessage={t.translate('modules.table.hint.message')}
      hintIconClassName="mdi mdi-information"
      hintMore={t.translate('modules.table.hint.more')}
      defaultData={[]}
      defaultSortBy="nama"
      columns={[
        {
          label: 'Pengenaan Pajak ID',
          searchable: true,
          key: 'pengenaanPajakId',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.pengenaanPajakId)
        },{
          label: 'Status',
          searchable: true,
          key: 'status',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.status)
        },{
          label: 'Tidak',
          searchable: true,
          key: 'tidak',
          type: TableWrapper.dataTypes.BOOLEAN,
          render: item => (item.tidak)
        },{
          label: 'Tipe Status Pajak ID',
          searchable: true,
          key: 'tipeStatusPajakId',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.tipeStatusPajakId)
        }
      ]}
      actions={[
        new TableWrapper.action('Add', 'mdi mdi-plus', () => history.push('/onpremise/status-pajak-penjual/baru'), true)
      ]}
      itemActions={[
        new TableWrapper.action('Edit', 'mdi mdi-pencil', (item) => history.push(`/onpremise/status-pajak-penjual/${item.id}`), true),
        new TableWrapper.action('Delete', 'mdi mdi-delete', (item) => { setConfirmDeleteData(item); setConfirmDelete(true)}, true)
      ]}
      onFetchData={ async query => {
        return service.get(query)
      }}
      showCommandbar={showCommandbar}
      showFilterPeriod={false}
    />
    <Modal.Confirm
      // title="Hapus Data"
      visible={confirmDelete}
      onRequestClose={_closeConfirmDelete}
      onSubmit={_submitConfirmDelete}
    >Hapus data {confirmDeleteData.nama}?</Modal.Confirm>
    </>
  )
}

export default StatusPajakPenjualTable
